module.exports = __webpack_public_path__ + "img/T7A6658.228ea5ae.jpg";